import {BaseSyntheticEvent, FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Datatable} from '../../../../components/Datatable/Datatable'
import {Button} from '../../../../components/Button/Button'
import Swal from 'sweetalert2'
import {POST, PUT} from '../../../../services/api'
import {Input} from '../../../../components/Input/Input'
import {Loading} from '../../../../components/Loading/Loading'
import {useNavigate} from 'react-router-dom'
import moment from 'moment'
import {i18n} from '../../../../translate/i18n'
import uuid from 'react-uuid'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'

type TypeListProduct = {
  id: string
  name: string
  price: string
  image: string
  sellerId: string
  allowDiscount: boolean
  sellerCatalog: boolean
}

type OrderType = {
  field: string
  type: 'ASC' | 'DESC'
}

type MetaType = {
  hasNextPage: boolean
  hasPreviousPage: boolean
  itemCount: number
  page: number
  pageCount: number
  take: number
}

const CriarCatalogosContent: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [loadingComp, setLoadingComp] = useState(false)
  const [name, setName] = useState('')
  const [order, setOrder] = useState('0')

  const [searchproduct, setSearchProduct] = useState('')
  const [listsearchproducts, setListSearchProducts] = useState<TypeListProduct[]>([])
  const [listProducts, setListProducts] = useState<TypeListProduct[]>([])

  const [startDate, setStartDate] = useState('')
  const [finalDate, setFinalDate] = useState('')

  const [image, setImage] = useState<File | null>(null)

  /*Novos Campos */
  const [linkCatalog, setLinkCatalog] = useState<string>('')
  const [sellerId, setSellerId] = useState<number>(0)
  const [isExclusive, setIsExclusive] = useState<boolean>(false)
  const [sellerCatalog, setSellerCatalog] = useState<boolean>(false)
  const [sellers, setSeller] = useState<any[]>([])
  const [meta, setMeta] = useState<MetaType | undefined>(undefined)

  const searchProduct = async (
    take: number = 200,
    page: number = 1,
    search: string = '',
    order: OrderType = {field: 'name', type: 'ASC'}
  ) => {
    try {
      if (!searchproduct.trim() && !search.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Informe o nome do produto, antes de pesquisa!',
        })
        return
      }
      let res
      if (!search.trim()) {
        setLoadingComp(true)
        res = await POST(`/product/productFilterCatalog?order=ASC&page=${page}&take=${take}`, {
          name: searchproduct,
          isInventoryGreaterThan: 1,
        })
      } else {
        setLoadingComp(true)
        if (listsearchproducts.length > 0) {
          /**
           * Perquisar produtos usando o array carregado listsearchproducts
           * usando o campo search
           */
          const resFilter = listsearchproducts.filter((product: any) => {
            return product.name.toLowerCase().includes(search.toLowerCase())
          })

          res = {
            data: resFilter,
            meta: {
              hasNextPage: false,
              hasPreviousPage: false,
              itemCount: resFilter.length,
              page: 1,
              pageCount: 1,
              take: 200,
            },
          }
        } else {
          res = await POST(
            `/product/productFilterCatalog?order=ASC&page=${page}&take=${take}&search=${search}`,
            {
              isInventoryGreaterThan: 1,
            }
          )
        }
      }

      setListSearchProducts(res.data)
      setMeta(res.meta)
      setLoadingComp(false)
    } catch (e) {
      setLoadingComp(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Um erro ocorreu ao filtrar os produto, verifique os nome informado!',
      })
    }
  }

  const addList = async (id: any) => {
    const newList = listProducts.map((product) => product)
    const oldList = newList.filter(function (row) {
      return row.id === id
    })
    const selected = listsearchproducts.filter(function (row) {
      return row.id === id
    })
    if (oldList.length === 0) newList.push(selected[0])
    setListProducts(newList)
  }

  const delList = (id: any) => {
    const newList = listProducts.filter((row) => row.id !== id)
    setListProducts(newList)
  }

  const create = async () => {
    try {
      if (
        !name ||
        !startDate ||
        !finalDate ||
        listProducts.length === 0 ||
        (sellerCatalog && !sellerId)
      ) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
        return
      }
      setLoading(true)
      let imageRes = {
        success: false,
        image: '',
      }
      const catalogItem = listProducts.map((row) => {
        return {
          productId: row.id,
          sellerId: row.sellerId,
          allowDiscount: sellerCatalog && row.allowDiscount,
          sellerCatalog: sellerCatalog,
          status: true,
        }
      })

      const resCatalog = await POST('/catalog', {
        catalog: name,
        dateStart: moment(startDate).format('YYYY-MM-DD 00:00:00'),
        dateEnd: moment(finalDate).format('YYYY-MM-DD 23:59:59'),
        order: order,
        sellerCatalog,
        sellerId,
        linkCatalog,
        isExclusive: isExclusive,
        catalogItem: catalogItem,
        imgCatalog: '',
      })
      if (image) {
        const formData = new FormData()
        formData.append('file', image)
        formData.append('nameImage', `catalog-${uuid()}.jpg`)
        imageRes = await POST('/upload-images/upload-one', formData)
        if (imageRes.success) {
          await PUT(`/catalog/${resCatalog.dados.id}`, {
            fotoCatalog: imageRes.image,
          })
        }
      }
      setLoading(false)

      if (resCatalog.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Catálogo cadastrado',
          text: 'Cadastro realizado com sucesso!',
        }).then(() => navigate(`/catalog`))
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao cadastrar o catálogo!',
        })
      }
    } catch (e) {
      setLoadingComp(false)
      console.log(e)
    }
  }

  async function loadSellers() {
    try {
      setLoading(true)
      const resSeller = await POST('/users/filter', {
        type: 'seller',
        status: true,
      })
      setLoading(false)

      if (!resSeller || !resSeller.success) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Não foi possivel carregar os vendedores!',
        })
        return
      }

      resSeller.data.unshift({name: 'Escolha um vendedor', id: 0, cpf: '0'})

      setSeller(
        resSeller.data
          .filter((seller: any) => seller.removed !== 1)
          .map((seller: any) => {
            return {
              select: seller.name,
              cpf: seller.cpf,
              value: seller.id,
            }
          })
      )
    } catch (error) {
      setLoading(false)
    }
  }

  function changeCatalogLink() {
    if (sellerCatalog) {
      const sellerFind = sellers.find((seller) => seller.value === sellerId)

      if (sellerFind) {
        setLinkCatalog(`?vendor=${window.btoa(sellerFind.cpf)}`)
      }
    }
  }

  useEffect(() => {
    loadSellers()
  }, [])

  useEffect(() => {
    if (sellerId) changeCatalogLink()
  }, [sellerId])

  const switchAllowDiscount = async (Id: number, status: boolean) => {
    try {
      const newProducts = listProducts.map((product) => {
        if (product.id === Id.toString()) {
          product.allowDiscount = !status
        }
        return product
      })
      setListProducts(newProducts)
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`smart_order.create_catalog`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(
                    `general.fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes`
                  )}
                </span>
              </h3>
            </div>
            <div className='card-body'>
              <div className='card-body border-bottom'>
                <div className='d-flex flex-row flex-wrap gap-10'>
                  <div>
                    <Input
                      inputAttr={{
                        type: 'image',
                      }}
                      label={i18n.t(`smart_order.image`)}
                      value={image}
                      change={(value: BaseSyntheticEvent) =>
                        setImage(value ? value.target.files[0] : null)
                      }
                    />
                  </div>
                  <div style={{flex: 1}}>
                    <div className='row'>
                      <div className='col-md-6'>
                        <Input
                          inputAttr={{
                            type: 'default',
                          }}
                          placeholder={i18n.t(`smart_order.name`)}
                          label={i18n.t(`smart_order.name`)}
                          value={name}
                          change={(value: string) => setName(value)}
                        />
                      </div>
                      <div className='col-md-2'>
                        <Input
                          inputAttr={{
                            type: 'number',
                          }}
                          placeholder={i18n.t(`smart_order.order`)}
                          label={i18n.t(`smart_order.order`)}
                          value={order}
                          change={(value: string) => setOrder(value)}
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-4'>
                        <Input
                          inputAttr={{type: 'date'}}
                          label={i18n.t(`smart_order.first`)}
                          value={startDate}
                          change={setStartDate}
                          maxLength={finalDate}
                        />
                      </div>
                      <div className='col-md-4'>
                        <Input
                          inputAttr={{type: 'date'}}
                          label={i18n.t(`smart_order.end`)}
                          value={finalDate}
                          change={setFinalDate}
                          minLength={startDate}
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='row'>
                        <Input
                          inputAttr={{type: 'checkbox'}}
                          label={'Catálogo Vendedor'}
                          value={sellerCatalog}
                          change={(value: boolean) => setSellerCatalog(value)}
                          checked={sellerCatalog}
                        />

                        {sellerCatalog && (
                          <div className='d-flex gap-4 align-items-center'>
                            <Input
                              inputAttr={{type: 'select'}}
                              label={'Selecione o Vendedor'}
                              value={sellerId}
                              options={sellers}
                              change={(value: string) => setSellerId(parseInt(value))}
                            />
                            {sellerId !== 0 && sellerId > 0 && (
                              <div
                                style={{
                                  marginTop: '3rem',
                                }}
                              >
                                <Input
                                  inputAttr={{type: 'checkbox'}}
                                  label={'Catálogo Exclusivo'}
                                  value={isExclusive}
                                  change={(value: boolean) => setIsExclusive(value)}
                                  checked={isExclusive}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <hr />

                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group mt-5'>
                      <label className='form-label fw-normal'>
                        {i18n.t(`smart_order.search_products`)}
                      </label>
                      <div className='input-group'>
                        <input
                          type='text'
                          className='form-control fw-normal'
                          placeholder={i18n.t(`smart_order.search_products`)}
                          value={searchproduct}
                          onChange={(event) => setSearchProduct(event.target.value)}
                        />
                        <div className='input-group-append'>
                          <button
                            className='btn btn-success'
                            style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
                            type='button'
                            onClick={() => searchProduct()}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-md-6'>
                    {loadingComp ? (
                      <Loading />
                    ) : (
                      <Datatable
                        data={listsearchproducts}
                        headers={[
                          {key: '#ID', value: 'id', type: 'default'},
                          {key: i18n.t(`smart_order.prod`), value: 'name', type: 'default'},
                          {key: i18n.t(`general.actions`), value: 'acoes', type: '', noOrder: true},
                        ]}
                        options={[
                          {
                            icon: 'fas fa-plus',
                            action: (item) => {
                              addList(item.id)
                            },
                            title: 'adicionar',
                          },
                        ]}
                        color='primary'
                        meta={meta}
                        onChangeData={async (take, page, search, order) =>
                          await searchProduct(take, page, search, order)
                        }
                        search
                      />
                    )}
                  </div>

                  <div className='col-md-6'>
                    {listProducts.length > 0 && (
                      <Datatable
                        data={listProducts}
                        headers={[
                          {key: '#ID', value: 'id', type: 'default'},
                          {key: i18n.t(`smart_order.prod`), value: 'name', type: 'default'},
                          {
                            key: 'Permitir Desconto',
                            value: 'allowDiscount',
                            type: 'check',
                            action: (item: any) => switchAllowDiscount(item.id, item.allowDiscount),
                            show: sellerCatalog,
                          },
                          {key: i18n.t(`general.actions`), value: 'acoes', type: '', noOrder: true},
                        ]}
                        options={[
                          {
                            icon: 'fas fa-trash',
                            action: (item) => {
                              delList(item.id)
                            },
                            title: 'remover',
                          },
                        ]}
                        color='primary'
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='d-flex w-100'>
                  <div className='col-6 d-flex justify-content-start'>
                    <Button
                      text={i18n.t(`buttons.back`)}
                      color='info'
                      size='small'
                      horizontalPadding={6}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => navigate(-1)}
                      btnClass='fw-bolder m-9'
                    />
                  </div>
                  <div className='col-6  d-flex justify-content-end'>
                    <Button
                      text={i18n.t(`buttons.save`)}
                      color='primary'
                      size='small'
                      horizontalPadding={6}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => create()}
                      btnClass='fw-bolder m-9'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const CriarCatalogos: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`smart_order.catalogs`), path: 'catalog', isActive: true},
          {title: i18n.t(`buttons.create`), path: 'catalog/criar', isActive: true},
        ]}
      >
        {`${i18n.t(`buttons.create`)} ${i18n.t(`smart_order.catalogs`)}`}
      </PageTitle>
      <CriarCatalogosContent />
    </>
  )
}

export {CriarCatalogos}
